export default class FollowUsConfig {
    constructor(public id: number, public url: string, public logoUrl: string) {

    }
}